import backendUrl from "./backendUrl";

export const brandApi = {
  createBrand: {
    url: `${backendUrl}/api/create-brand`,
    method: "post",
  },
  getAllBrandsAdmin: {
    url: `${backendUrl}/api/get-brands-admin`,
    method: "get",
  },
  updateBrand: {
    url: `${backendUrl}/api/update-brand`,
    method: "put",
  },
  deleteBrand: {
    url: `${backendUrl}/api/delete-brand`,
    method: "delete",
  },
  dashboardStats: {
    url: `${backendUrl}/api/dashboard-stats`,
    method: "get",
  },
};
